import { Link } from "react-router-dom";

/** City-specific academy CTA: train locally, get certified, get considered for solar jobs. */
export default function AcademyCityCta({ city }) {
  return (
    <section className="section" data-testid="city-academy-cta" style={{ paddingTop: 34 }}>
      <div className="academy-belt-card" style={{ flexDirection: "row", alignItems: "center", flexWrap: "wrap", gap: 22, padding: "26px 26px" }}>
        <img src="/academy-assets/ninja-stand.jpg" alt="Roi Solar inviting you to train at the academy" loading="lazy"
          style={{ width: 132, height: 132, objectFit: "cover", borderRadius: 14 }} />
        <div style={{ flex: 1, minWidth: 260 }}>
          <span className="eyebrow">GET A JOB IN SOLAR — {city.name.toUpperCase()}</span>
          <h2 style={{ margin: "8px 0 10px" }}>Train in {city.name}. Get certified. Get considered.</h2>
          <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6 }}>
            The Solar Black Belt Academy is free and self-paced — start at White Belt, earn your way to Black Belt,
            and add the Powerwall Product Knowledge Certificate. Finishing enables hiring consideration for installer,
            sales and support roles serving {city.name} and the rest of Florida. It is never an automatic job offer.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 14 }}>
            <Link className="btn small lime" data-testid="city-academy-enroll" to="/academy">Train for your belts ↗</Link>
            <Link className="btn small" data-testid="city-academy-careers" to="/academy/careers">Join the hiring pipeline</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
